// import { interceptorOnResponse, interceptorOnResponseError } from '~/utils/refresh-token-interceptor.js';

export default defineNuxtPlugin(async () => {
  const auth = useAuth();
  const config = useRuntimeConfig();
  const _apiV1 = $fetch.create({
    baseURL: config.public.apiV1BaseUrl,
    headers: {
      Authorization: `Bearer ${auth.idToken.value}`,
    },
    async onResponseError({ response, options }) {
      //TODO: review this refresh flow for ofetch and add it to apiv2
      if (response.status === 401) {
        const renewJoinedInflight = isRenewInFlight();
        const pendingRenew = renewSession();
        await trackAuthError('token_invalid', null, undefined, {
          renew_joined_inflight: renewJoinedInflight,
        });
        const result = await pendingRenew;
        if (result.outcome !== 'renewed' && result.outcome !== 'recovered') return;
        if (!result.user.id_token) return;
        options.headers['Authorization'] = `Bearer ${result.user.id_token}`;
        return $fetch(options);
      }
    },
  });
  const apiV2 = $fetch.create({
    baseURL: `${config.public.apptegyOIDCUrl}/api/v2`,
    headers: {
      Authorization: `Bearer ${auth.idToken.value}`,
    },
  });
  //TODO: add interceptors to apis
  // instance.interceptors.response.use(interceptorOnResponse(), interceptorOnResponseError(instance));
  return {
    provide: {
      authServiceFetchV2: apiV2,
    },
  };
});
